import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ClientContainer from '../../ClientContainer';
import BannerStrip from '../../Common/Containers/BannerStrip';
import ActivitiesTable from './ActivitiesTable';
import ActivityItems from './ActivityItems';
import useCloseDrawers from '../../../hooks/useCloseDrawers';
import useShowDetailsFromDashboard from '../../../hooks/useShowDetailsFromDashboard';
import { RootState } from '../../../../../redux/root';
import { setShowDrawerContent } from '../../../../../redux/slices/generalSlice';
import { ModalDefaultDraggable } from '../../../../../molecules';

const Activities = () => {
  useCloseDrawers();
  useShowDetailsFromDashboard();
  const dispatch = useDispatch();
  const showDrawerContent = useSelector((s: RootState) => s.general.showDrawerContent);
  const selectedActivityPermit = useSelector(
    (s: RootState) => s.clientActivities.SelectedActivityPermit,
  );

  const handleClose = () => dispatch(setShowDrawerContent(false));

  // @ts-ignore
  const title = selectedActivityPermit?.namePermitName || 'Permit Activities';

  return (
    <ClientContainer>
      <BannerStrip label="Activities" />
      <TableStage>
        <ActivitiesTable />
      </TableStage>
      {showDrawerContent && (
        <ModalDefaultDraggable
          title={title}
          onClose={handleClose}
          extraWide
          maxWidth="1240px"
          addContactModal
        >
          <ActivityItems />
        </ModalDefaultDraggable>
      )}
    </ClientContainer>
  );
};

export default Activities;

const TableStage = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
